import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Dialog } from 'tdesign-react';
import HostTable from '@/pages/Maintenance/Resource/Host/components/HostTable';

function SelectHostModal({ visible, handleClose, clusterId, hosts }) {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (visible) {
      setRows(hosts);
    }
  }, [visible, hosts]);

  const onConfirm = () => {
    handleClose(rows);
  };

  return (
    <Dialog
      header='选择主机'
      visible={visible}
      onClose={() => handleClose()}
      onConfirm={onConfirm}
      placement='center'
      destroyOnClose
      width={'80%'}
    >
      <HostTable
        clusterId={clusterId}
        selectOnRowClick
        selectedRowData={rows}
        onSelectChange={(val, { selectedRowData }) => setRows(selectedRowData)}
      />
    </Dialog>
  );
}

export default connect((state) => ({
  hosts: state.execScript.hosts,
}))(SelectHostModal);
